<template>
    <div>
        <div class="page-header clear-filter" filter-color="black" style="height: 1080px!important;">
            <parallax
                    class="page-header-image"
                    style="z-index:0;background-image:url('img/background.png')"
            >
            </parallax>
            <div class="container">
                <div class="content-center brand">
                    <img class="n-logo" style="max-width:650px!important;width:100%!important;" src="img/now-logo.png" alt="" />
                    <h3 style="font-size:40px;">Coming Soon...</h3><br><br><br>
                    <div>
                        <flip-countdown deadline="2019-10-03 00:00:00"></flip-countdown>
                    </div>
                    <br><br>
                    <div style="margin-top:0%!important;margin-bottom:-30%!important;">
                        <h3>Follow us</h3>
                        <div class="text-center justify-center col-md-12">
                        <a
                                target="_blank"
                                href="https://www.twitter.com/transpo_india"
                                class="btn btn-neutral btn-icon btn-twitter btn-round btn-lg"
                                rel="tooltip"
                                title="Follow us"
                        >
                            <i class="fab fa-twitter"></i>
                        </a>
                        <a
                                target="_blank"
                                href="https://www.facebook.com/india.transpo"
                                class="btn btn-neutral btn-icon btn-facebook btn-round btn-lg"
                                rel="tooltip"
                                title="Like us"
                        >
                            <i class="fab fa-facebook-square"></i>
                        </a>
                        <a
                                target="_blank"
                                href="https://www.linkedin.com/company/transpo"
                                class="btn btn-neutral btn-icon btn-linkedin btn-lg btn-round"
                                rel="tooltip"
                                title="Follow us"
                        >
                            <i class="fab fa-linkedin"></i>
                        </a>
                        <a
                                target="_blank"
                                href="https://instagram.com/transpoindia"
                                class="btn btn-neutral btn-icon btn-round btn-lg"
                                rel="tooltip"
                                title="Follow on Instagram"
                        >
                            <i class="fab fa-instagram"></i>
                        </a>
                    </div><br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FlipCountdown from 'vue2-flip-countdown'
export default {
    components: { FlipCountdown },
    name: "coming-soon",
    bodyClass: 'index-page',
}
</script>

<style>
    .flip-card__top[data-v-72281230], .flip-card__bottom[data-v-72281230], .flip-card__back-bottom[data-v-72281230], .flip-card__back[data-v-72281230]::before, .flip-card__back[data-v-72281230]::after {
        color:#F9F9F9!important;
    }
    .index-page .page-header{
        height:100vh!important;
    }
    .section-images{
        max-height: 600px!important;
    }
    .n-logo{
        max-width:300px!important;
        /*padding-top:60px;*/
    }
    .index-page .page-header .container > .content-center{
        top:46%!important;
    }
</style>
